import React, { Component } from 'react'
import {GetQueryVariable, SlackToken } from '../utils/util-networkCalls.js';
const { WebClient } = require('@slack/web-api');

const slackClientId = process.env.REACT_APP_SLACK_CLIENT_ID;
const slackScope = "incoming-webhook";
const slackState = "test"
const redirectUrl = "http://localhost:3000/";
const slackClientSecret = process.env.REACT_APP_SLACK_CLIENT_SECRET;

class SlackBtn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      slackToken: undefined
    };
  }
  componentDidMount() {
    let slackCode = GetQueryVariable("code");
    if(typeof this.state.slackCode === 'undefined' && typeof slackCode !== 'undefined'){
      this.setState({ slackCode: slackCode });
      SlackToken(slackCode, slackClientId, slackClientSecret).then(response =>{
        if(typeof response.error === 'undefined'){
          this.setState({
            slackToken: response.access_token,
            slackWebhook: response.incoming_webhook.url,
            slackChannel: response.incoming_webhook.channel
          })

          this.props.getSlackWebhook(response.incoming_webhook.url);
        }
      });
    }
  }
  render() {
      //  console.log(this.state);
    return (
      <a href={"https://slack.com/oauth/v2/authorize?client_id="+slackClientId+"&scope="+slackScope+"&user_scope=&state="+slackState}><img alt="Add to Slack" height="40" width="139" src="https://platform.slack-edge.com/img/add_to_slack.png" srcSet="https://platform.slack-edge.com/img/add_to_slack.png 1x, https://platform.slack-edge.com/img/add_to_slack@2x.png 2x" /></a>
    )
  }
}

export default SlackBtn;
